import { render, staticRenderFns } from "./TranBillReport.vue?vue&type=template&id=a1eae6ea&"
import script from "./TranBillReport.vue?vue&type=script&lang=js&"
export * from "./TranBillReport.vue?vue&type=script&lang=js&"
import style0 from "./TranBillReport.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QInput,QIcon,QBtn,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QInput,QIcon,QBtn,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
